import './style.scss'
import React from 'react'
import { Card } from 'src/componentv2/Base/Card'
import { Rectangle } from 'src/componentv2/Base/Rectangle'
import { Badge } from 'src/componentv2/Base/Badge'
import { Button, ButtonProps } from 'src/componentv2/Base/Button'
import { Flex, Text, tokens, UIProps } from 'src/componentv2/Base/ui'

export interface StepBadge {
    label?: React.ReactNode
    icon?: React.ReactNode
    bgColor?: string
    color?: string
}

export interface StepAction extends Partial<ButtonProps> {
    label: React.ReactNode
}

export interface StepCardProps extends UIProps {
    title: React.ReactNode
    description: React.ReactNode
    illustration?: React.ReactNode
    illustrationBg?: string
    illustrationHeight?: string
    badge?: StepBadge
    action?: StepAction
    onAction?: () => void
    titleColor?: string
    descriptionColor?: string
    children?: React.ReactNode
}

export const StepCard: React.FC<StepCardProps> = ({
                                                      title,
                                                      description,
                                                      illustration,
                                                      illustrationBg = tokens.primarySoft,
                                                      illustrationHeight = '13',
                                                      badge,
                                                      action,
                                                      onAction,
                                                      titleColor = tokens.textDark,
                                                      descriptionColor = tokens.textMuted,
                                                      minHeight = '32',
                                                      padding = '1.6',
                                                      fluidOn = 640,
                                                      className = '',
                                                      children,
                                                      ...rest
                                                  }) => (
    <Card
        className={`step-card ${className}`}
        minHeight={minHeight}
        padding={padding}
        fluidOn={fluidOn}
        {...rest}
    >
        <Rectangle
            className="step-card__illustration"
            height={illustrationHeight}
            radius="0.8"
            bgColor={illustrationBg}
        >
            {illustration}

            {badge && (
                <Badge
                    className="step-card__badge"
                    icon={badge.icon}
                    bgColor={badge.bgColor ?? tokens.white}
                    color={badge.color}
                    shadow={tokens.shadowCard}
                >
                    {badge.label}
                </Badge>
            )}
        </Rectangle>

        <div className="step-card__content">
            <Text
                className="step-card__title"
                topMargin="1.6"
                fontSize="1.7"
                color={titleColor}
            >
                {title}
            </Text>

            <Text
                className="step-card__description"
                topMargin="0.6"
                fontSize="1.4"
                color={descriptionColor}
            >
                {description}
            </Text>

            {children}
        </div>

        {action && (
            <Flex className="step-card__footer" justify="flex-end">
                <Button
                    variant={action.variant ?? 'ghost'}
                    size={action.size ?? 'md'}
                    icon={action.icon}
                    iconPosition={action.iconPosition}
                    onClick={onAction ?? action.onClick}
                    {...action}
                >
                    {action.label}
                </Button>
            </Flex>
        )}
    </Card>
)

export default StepCard